import { FiTarget, FiEye, FiAward, FiUsers, FiGlobe, FiHeart } from "react-icons/fi";

export const values = [
  {
    icon: FiTarget,
    title: "Innovation",
    desc: "We continuously explore modern technologies and creative development approaches to build future-ready digital solutions for evolving business needs.",
    color: "from-orange-500 to-red-500",
  },
  {
    icon: FiEye,
    title: "Transparency",
    desc: "Clear communication, honest collaboration, and regular project updates help us maintain trust and alignment throughout every development stage.",
    color: "from-cyan-500 to-blue-500",
  },
  {
    icon: FiAward,
    title: "Quality",
    desc: "We follow structured development standards and rigorous testing processes to deliver reliable, stable, and high-performing digital products.",
    color: "from-yellow-400 to-orange-500",
  },
  {
    icon: FiUsers,
    title: "Collaboration",
    desc: "Our team works closely with clients, understanding their goals and workflows to create solutions that align with real business objectives.",
    color: "from-purple-500 to-pink-500",
  },
  {
    icon: FiGlobe,
    title: "Global Reach",
    desc: "With a presence across India, the UK, and the US, we support businesses worldwide with scalable and modern technology solutions.",
    color: "from-green-500 to-emerald-500",
  },
  {
    icon: FiHeart,
    title: "Client Focus",
    desc: "We prioritize client success by building practical, user-focused, and growth-driven digital experiences tailored to unique business requirements.",
    color: "from-rose-500 to-pink-500",
  },
];
